import { getField, updateField } from 'vuex-map-fields'

import order from '../../../api/order/'

// initial state
// shape: [{ id, quantity }]
const state = {
  checkoutInfo: {}
}

// getters
const getters = {
  getField
}

// actions
const actions = {
  getCheckoutInfo ({ commit }, id) {
    const data = {
      OrderId: parseInt(id)
    }
    return new Promise((resolve, reject) => {
      order.getCheckoutInfo(data)
        .then(res => {
          commit('setCheckoutInfo', res)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  applyVoucher ({ commit }, data) {
    return new Promise((resolve, reject) => {
      order.applyVoucher(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  changeDeliveryDate ({ commit }, data) {
    return new Promise((resolve, reject) => {
      order.changeDeliveryDate(data)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  complete ({ commit }, data) {
    return new Promise((resolve, reject) => {
      order.complete(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  thankyou ({ commit }, data) {
    return new Promise((resolve, reject) => {
      order.thankyou(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      order.getList(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getDetail ({ commit }, data) {
    return new Promise((resolve, reject) => {
      order.getDetail(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeOrder ({ commit }, data) {
    return new Promise((resolve, reject) => {
      order.remove(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  cancelRequest ({ commit }) {
    order.cancelRequest()
  }
}

// mutations
const mutations = {
  updateField,
  setCheckoutInfo (state, detail) {
    state.checkoutInfo = detail
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order/index.js